import {reactive} from "vue";
import {WarrantySearchModelType} from "@/types/WarrantySearchModelType";
import {WarrantySelectableType} from "@/types/WarrantySelectableType";
import {CicSearchModelType} from "@/types/CicSearchModelType";

interface StoreType {
    cicSearchModel: CicSearchModelType
    availableShopSystems: Array<string>
    warrantySearchModel: WarrantySearchModelType|null
    warranty: WarrantySelectableType
}

export const store = reactive<StoreType>({
    cicSearchModel: {
        number:'',
        email:'',
        shopSystem: null,
    },
    availableShopSystems: [
            '',
            'shop-de',
            'shop-at',
            'shop-ch',
            'shop-uk',
            'shop-bg',
            'shop-ch',
            'shop-fr',
            'wvk',
            'cb',
            'esi',
            'esich',
            'isc',
        ],
    warrantySearchModel: {
        email:'',
        serialnumber:'',
        firstname:'',
        lastname:'',
    },
    warranty: {
        availableCountries: [],
        availableLocales: [
            'en'
        ],
        availableDomains: []
    }
})
